import populate from './populate'
import content from './vychovakzivotu'

const populated = populate(content)

if (process.env.NODE_ENV === 'development') {
  window.data = {
    original: content,
    populated,
  }
}

export default populated



// WEBPACK FOOTER //
// ./src/content/index.js